import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CustomizerSettingsService {
  private isDarkTheme: boolean;

  constructor() {
    this.isDarkTheme = JSON.parse(localStorage.getItem('isDarkTheme')!);
  }

  setTheme(isDark: boolean) {
    this.isDarkTheme = isDark;

    localStorage.setItem('isDarkTheme', JSON.stringify(this.isDarkTheme));

    if (isDark) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
  }

  isDark() {
    return this.isDarkTheme;
  }
}
